import { generatePath } from "react-router";
import { Link } from "react-router";

import type { DiscountOrdinary } from "@/lib/gql/__generated__/graphql";

import { QUERY_PARAMS } from "@/routes/_constants/query-params";
import { PATHS } from "@/routes/paths";

type Props = {
	activeDiscounts: Pick<DiscountOrdinary, "discountID" | "name" | "hotelID">[] | undefined;
	title: string;
};

export const ActiveDiscountsList = ({ activeDiscounts, title }: Props) => {
	const hasDiscounts = activeDiscounts && activeDiscounts.length > 0;

	return (
		<div className="mt-4 border-zinc-200 p-3">
			<h4 className="mb-2 text-sm">{title}</h4>
			{hasDiscounts ? (
				<div className="grid grid-cols-1 gap-x-4 gap-y-1 md:grid-cols-2">
					{activeDiscounts.map((discount) => {
						const path = generatePath(PATHS.HOTEL.ITEMS.DISCOUNT.EDIT, {
							hotelID: discount.hotelID,
							type: QUERY_PARAMS.ITEMS.DISCOUNT.TYPE.ORDINARY,
							discountID: discount.discountID,
						});

						return (
							<Link
								key={discount.discountID}
								to={path}
								target="_blank"
								rel="noopener noreferrer"
								className="min-w-0 break-all py-1 text-sm font-normal text-link-400 underline-offset-4 hover:underline"
							>
								{discount.name}
							</Link>
						);
					})}
				</div>
			) : (
				<p className="text-sm text-zinc-600">適用されているディスカウントは存在しません。</p>
			)}
		</div>
	);
};

ActiveDiscountsList.displayName = "ActiveDiscountsList";
